import React from 'react';
import { Star } from 'lucide-react';

const RatingStars = ({ rating = 0, size = 16 }) => {
  const stars = [];

  for (let i = 0; i < 5; i++) {
    const fillLevel = rating - i;

    if (fillLevel >= 1) {
      // Full star
      stars.push(
        <Star
          key={i}
          size={size}
          className="text-yellow-400 fill-yellow-400"
        />
      );
    } else if (fillLevel >= 0.5) {
      // Half star using clip
      stars.push(
        <div key={i} className="relative w-fit">
          <Star size={size} className="text-gray-300" />
          <Star
            size={size}
            className="text-yellow-400 fill-yellow-400 absolute top-0 left-0"
            style={{ clipPath: 'inset(0 50% 0 0)' }}
          />
        </div>
      );
    } else {
      // Empty star
      stars.push(
        <Star key={i} size={size} className="text-gray-300" />
      );
    }
  }

  return (
    <div className="flex justify-center items-center gap-0.5">
      {stars}
    </div>
  );
};

export default RatingStars;
